import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';

/* Danke-Seite nach dem Einrichten des Stripe-Abos fürs Ernährungscoaching (E23, 15.10.2026). Öffentlich, ohne Personendaten:
   fragt nur den Stand der Zahlung ab. Schlicht wie die übrigen öffentlichen Seiten (nicht crm-neu). */
export default function ErnaehrungBezahltPage() {
  const [params] = useSearchParams();
  const sitzung = params.get('sitzung');
  const [d, setD] = useState(null);
  const [fehler, setFehler] = useState(false);
  useEffect(() => {
    document.title = 'Ernährungscoaching — P1';
    if (!sitzung) return;
    axios.get(`${process.env.REACT_APP_BACKEND_URL || ''}/api/ernaehrung-zahlung/bestaetigen`, { params: { sitzung } })
      .then((r) => setD(r.data)).catch(() => setFehler(true));
  }, [sitzung]);
  return (
    <main className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center px-5 py-12">
      <div className="w-full max-w-md text-center space-y-5">
        <img src="/logo-weiss-kompakt.png" alt="P1 Performance Center" className="mx-auto h-14 w-auto object-contain" />
        {params.get('abgebrochen') ? (
          <><h1 className="text-2xl font-bold">Abgebrochen</h1><p className="text-white/70">Es wurde nichts abgebucht. Der Link aus deiner E-Mail bleibt 24 Stunden gültig — danach schicken wir dir gern einen neuen.</p></>
        ) : fehler || !sitzung ? (
          <><h1 className="text-2xl font-bold">Wir prüfen deine Zahlung</h1><p className="text-white/70">Der Stand konnte gerade nicht abgerufen werden. Sobald die Zahlung verbucht ist, schaltet die P1 App den Essen-Bereich frei.</p></>
        ) : !d ? <p className="text-white/70">Einen Moment …</p> : d.status === 'bezahlt' ? (
          <>
            <h1 className="text-3xl font-extrabold">Danke, das hat geklappt.</h1>
            <p className="text-white/80">Dein {d.produkt || 'Ernährungscoaching'} ist eingerichtet{d.start ? ` und startet am ${new Date(`${d.start}T12:00:00`).toLocaleDateString('de-DE')}` : ''}. Die P1 App zeigt dir ab dem Start den Essen-Bereich.</p>
          </>
        ) : <><h1 className="text-2xl font-bold">Zahlung noch offen</h1><p className="text-white/70">Deine Zahlung ist noch nicht eingegangen. Sobald sie da ist, geht es in der P1 App los.</p></>}
        <p className="text-xs text-white/40">P1 Performance Center GmbH · Georg-Stieß-Straße 2 · 75181 Pforzheim</p>
      </div>
    </main>
  );
}
